export class WorkItemDiscarded {
}